// Module
var code = "<div class=\"flex flex-column fit\" data-bind=\"html: hint.suggestion\"></div>";
// Exports
export default code;